export enum MimeValueType {
  Json = 'application/json',
  Html = 'text/html',
  Text = 'text/plain',
  FormUrlEncoded = 'application/x-www-form-urlencoded',
  MultipartFormData = 'multipart/form-data'
}
